<div class="myField {{highlight}}"
     [ngClass]="{
    'highlight': active,
    'd-inline-block': !show.label && fieldOptions?.displayType !== 'map',
    'd-block margin-bottom': (show.value && fieldOptions?.cssClass !== 'd-inline-block') || fieldOptions?.displayType === 'map'
  }">


  <h6 *ngIf="show?.label === true">
    {{field?.UILabel || field?.DisplayText || 'No title'}}
    <span>
      <button *ngIf="historical.length"
              #changesEl
              class="btn btn-sm cv-btn-revised_fields"
              (click)="showHistorical()">
        <i class="fas fa-book"></i>
        <span>{{ historical.length }}</span>
      </button>
    </span>
  </h6>
  <div *ngIf="show?.label === false">
    <button *ngIf="historical.length"
            #changesEl
            class="btn btn-sm cv-btn-revised_fields"
            (click)="showHistorical()">
      <i class="fas fa-book"></i>
      <span>{{ historical.length }}</span>
    </button>
  </div>

  <!-- <h6 *ngIf="show?.label === true">{{field?.UILabel || field?.DisplayText || 'No title'}}</h6> -->

  <div *ngIf="fieldOptions?.displayType === 'map' && show.value">

    <cv-component-map [mapConfiguration]="mapConfiguration"
                      [zoom]="15"
                      [height]="'300px'">
    </cv-component-map>
  </div>

  <div *ngIf="fieldOptions?.displayType !== 'map' && show.value">

    <p [ngClass]="fieldOptions?.cssClass"
       [ngSwitch]="fieldOptions?.displayType">

      <span *ngIf="iconExist">
        <i class="{{icons[icon]}}"></i>
      </span>
      <span *ngSwitchCase="'bool'">
        <span *ngIf="value==='Y' || value === 'True'"><i class="fa fa-check"></i>Yes</span>
        <span *ngIf="value==='N' || value === 'False'"><i class="fa fa-times"></i>No</span>
        <span *ngIf="['--',''].indexOf(value) > -1">--</span>
      </span>

      <span *ngSwitchCase="'currency'">{{isNumber(value) ? (parseNumeric(value) | currency): value || '--'}}</span>
      <span *ngSwitchCase="'thousands-currency'">{{isNumber(value) ? ((parseNumeric(value) * 1000) | currency): value ||
        '--'}}</span>
      <span *ngSwitchCase="'gla'">{{isNumber(value) ? (value | number): value}} Sq. Ft.</span>
      <span *ngSwitchCase="'years'">{{isNumber(value) ? (value | number): value}} years</span>
      <span *ngSwitchCase="'percentage'">{{value}} %</span>

      <span *ngSwitchDefault>{{value || '--'}}</span>
    </p>

    <!-- <div>
      <button #changesEl
        *ngIf="historical.length"
        class="btn btn-sm cv-btn-revised_fields"
        (click)="showHistorical()">
        <i class="fas fa-book"></i>
				<span>{{ historical.length }}</span>
      </button>
    </div> -->
  </div>
</div>